import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-19186 Добавить роль комментирования в настройки шаринга
 * @property {showCommentFileOption} - Показываем в дропдауне опцию на комментирование
 * @property {showCommentFileViewer} - Можем ли открыть R7 на комментирование
 */
export const showCommentFileOption = isFeature('show-comment-file-option') || false;

export const showCommentFileViewer = isFeature('show-comment-file-viewer') || false;
